'use client'

import { HoverDelayInspiration } from 'header/constants/hoverDelays'
import { useHover } from 'header/hooks/useHover'
import { useMenuLabels } from 'header/hooks/useMenuLabels'
import { useMenuOpenState } from 'header/hooks/useMenuOpenState'
import { useMenus } from 'header/hooks/useMenus'
import { useHeaderState } from 'hooks/useHeaderContext/useHeaderState'
import { Responsive } from 'responsive/components/Responsive/Responsive'
import { applyStylesIf, cx } from 'utils/cx'

import { OpenMenu } from '../OpenMenu/OpenMenu'
import { StructureLPlus } from '../Structure/StructureLPlus'
import { StructureSM } from '../Structure/StructureSM'

import styles from './WrapperMenu.module.scss'

export function WrapperMenu() {
	const { open, firstOpen, hasDataLoaded, updateOpen } = useMenus()
	const { isSearchOpen } = useHeaderState()

	const { openFixed } = useMenuOpenState(open)

	const { isMenuLabelsReady } = useMenuLabels(firstOpen)

	const handleOnMouseEnter = () => {
		if (openFixed) {
			updateOpen(false)
		}
	}

	const { ref } = useHover<HTMLDivElement>(
		HoverDelayInspiration.OUTSIDE,
		handleOnMouseEnter
	)

	if (isSearchOpen) {
		return null
	}

	return (
		<div
			className={styles.menu}
			data-testid='inspirational.menu'
			id='wrapperMenu'
		>
			<OpenMenu />
			{hasDataLoaded && firstOpen && isMenuLabelsReady && (
				<>
					<div
						id='menuBackdrop'
						className={cx(
							styles.menuBackdrop,
							applyStylesIf(open, styles.open),
							applyStylesIf(!open, styles.close)
						)}
						ref={ref}
						data-testid='inspirational.menuBackdrop'
					/>
					<Responsive onLargeOrGreater>
						<StructureLPlus />
					</Responsive>
					<Responsive onLessThanLarge>
						<StructureSM />
					</Responsive>
				</>
			)}
		</div>
	)
}
